import PropChainTracker from "../../prop-tracker-utils/prop-chain-tracker.js";
import Groups from "../../prop-tracker-utils/groups.js";
import ValueTracker from "../../prop-trackers/value-tracker.js";
import ValueTrackerObjGen from "../../prop-tracker-utils/value-tracker-obj-gen.js";
import copyGroupTrackerToProps from "../../prop-tracker-utils/copy-group-tracker-to-props.js";

class ElementByType {
    constructor(wrapCtx, evtCtx, types, createTypeTracker) {
        this._types = types;

        this._tracker = new PropChainTracker(evtCtx);
        this._byTypeTrackers = {};
        this._byTypeGens = {};
        this._byTypeDicts = {};

        for (const type of types) {
            const typeTracker = new ValueTracker();
            this._byTypeTrackers[type] = typeTracker;
            this._byTypeGens[type] = new ValueTrackerObjGen(wrapCtx, evtCtx, typeTracker);
            this._byTypeDicts[type] = wrapCtx.getWrapper({});
        }

        Object.freeze(this._byTypeGens);

        this._groups = new Groups(this._tracker, types, (key) => createTypeTracker(key));
    }

    get elements() { return this._byTypeGens; }

    track(elementData) {
        if (elementData) {
            this._tracker.track(elementData.data, ["value"]);

            for (const type of this._types) {
                this._byTypeTrackers[type].setValue(this._byTypeDicts[type]);
            }
        } else {
            this._tracker.track();

            for (const type of this._types) {
                this._byTypeTrackers[type].deleteValue();
            }
        }
    }

    update() {
        copyGroupTrackerToProps(this._byTypeDicts, this._groups);

        for (const type of this._types) {
            this._byTypeGens[type].update();
        }
    }
}

export default ElementByType;


